import { Badge, ColorVariant, getOrgRoleIcon } from '@makyoapp/makyo-ui'

import { useCurrentOrgContext } from '@/context/CurrentOrgContext'
import { useOrgsContext } from '@/context/OrgsContext'
import useAuth from '@/hooks/useAuth'
import { useDateFmt } from '@/hooks/useDateFmt'
import QuickStatsSection from '@/pages/org/dashboard/components/QuickStatsSection'

import BillingSection from './components/BillingSection'
import ManagementSection from './components/ManagementSection'
import OrganizationSection from './components/OrganizationSection'
import QuickActionSection from './components/QuickActionSection'
import SystemUsageSection from './components/SystemUsageSection'
import WelcomeAvatar from './components/WelcomeAvatar'

const Dashboard = () => {
  const { currentOrg } = useCurrentOrgContext()
  const { recentApps } = useOrgsContext()

  const dateFmtDefault = useDateFmt()
  const { userData } = useAuth()

  if (!currentOrg || !userData) return null

  const orgRole = (currentOrg.members || []).find((m) => m.userId === userData?.id)?.orgRole
  const plan = recentApps.find((o) => o.org.id === currentOrg?.id)?.plan || {
    name: 'FREE',
    badgeColor: ColorVariant.Yellow,
  }

  return (
    <div className='min-h-screen bg-linear-to-br from-slate-50 via-white to-slate-50 dark:from-slate-900 dark:via-slate-800 dark:to-slate-900 text-slate-900 dark:text-white'>
      <nav className='border-b border-slate-200/50 dark:border-slate-700/50 bg-white/50 dark:bg-slate-900/50 backdrop-blur-xs'>
        <div className='mx-auto px-6 py-4'>
          <div className='flex items-center justify-between w-full'>
            <div className='flex items-start gap-4 w-full flex-1'>
              <div className='relative max-w-20'>
                <WelcomeAvatar />
              </div>
              <div className='w-full'>
                <div className='flex items-center gap-2 mb-1'>
                  <h1 className='text-xl text-slate-800 dark:text-slate-200'>Welcome to {currentOrg?.name}</h1>
                </div>
                <div className='flex justify-between'>
                  <p className='text-sm text-slate-600 dark:text-slate-400 flex items-center'>
                    Your organization access level is
                    <span className='inline-flex gap-1 items-center h-full mx-1 uppercase'>
                      {getOrgRoleIcon(orgRole!)} {orgRole}
                    </span>
                  </p>

                  <div className='flex items-center gap-2'>
                    <span className='text-sm text-slate-600 dark:text-slate-400'>
                      Created: {dateFmtDefault(currentOrg.created)}
                    </span>
                    <Badge color={plan?.badgeColor as ColorVariant} className='ml-2 text-xs'>
                      {plan?.name}
                    </Badge>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <div className='mx-auto px-6 py-8'>
        <QuickStatsSection />

        <div className='grid grid-cols-12 gap-8'>
          <div className='col-span-8'>
            <QuickActionSection />

            <ManagementSection />

            <OrganizationSection />
          </div>

          <div className='col-span-4 space-y-8'>
            <SystemUsageSection />

            <BillingSection />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Dashboard
